<template>
  <div>
    <div @click.stop="moreInfo = !moreInfo"
         class="asset-list-grid
              py-3 items-center text-right rounded
              hover:bg-line cursor-pointer transition duration-200 -mx-4 px-4
              text-sm text-text-secondary font-medium">
      <AssetIcon :instrument="asset.instrument"/>
      <div class="text-left truncate">{{ asset.instrument.ticker }}</div>
      <div class="text-left">{{ asset.instrument.name }}</div>
      <div :class="{
        'text-red':asset.profit_percent_day<0,
        'text-green':asset.profit_percent_day>0}">
        {{ asset.profit_percent_day.toFixed(2) }}
      </div>
      <div :class="{
        'text-red':asset.profit_percent<0,
        'text-green':asset.profit_percent>0}">
        {{ asset.profit_percent.toFixed(2) }}
      </div>
      <div>{{ asset.amount }}</div>

      <div>{{ displayCurrencyValue(asset.price, assetCurrency) }}</div>
      <div>{{ displayCurrencyValue(asset.sum, assetCurrency) }}</div>
      <div :class="{
        'text-red':asset.profit_absolute_base < 0,
        'text-green':asset.profit_absolute_base > 0}">
        {{ displayCurrencyValue(asset.profit_absolute, assetCurrency) }}
      </div>
      <div>
        <v-popover placement="left"
                   offset="10"
                   open-group="asset-popover"
                   popoverClass="invest-asset__popover">
          <button class="focus:outline-none text-border hover:text-border-hover transition duration-200">
            <IconDotsMore/>
          </button>
          <!--                    <template slot="popover">-->
          <!--                      <button class="invest-asset__btn"-->
          <!--                              v-close-popover-->
          <!--                              @click="$emit('showHistory',asset.instrument)">-->
          <!--                        История-->
          <!--                      </button>-->
          <!--                      <button v-if="asset.type !== 4" class="invest-asset__btn"-->
          <!--                              v-close-popover-->
          <!--                              @click="addDeal(asset.instrument,1)">-->
          <!--                        Купить-->
          <!--                      </button>-->
          <!--                      <button v-if="asset.type !== 4" class="invest-asset__btn"-->
          <!--                              v-close-popover-->
          <!--                              @click="addDeal(asset.instrument,2)">-->
          <!--                        Продать-->
          <!--                      </button>-->
          <!--                    </template>-->
        </v-popover>
      </div>
    </div>
    <TransitionCollapseHeight class="-mx-8 lg:-mx-12 ">
      <div v-show="moreInfo">
        <AssetMoreInfo :asset="asset" :currency="assetCurrency"/>
      </div>
    </TransitionCollapseHeight>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";
import IconDotsMore from "@/components/icons/IconDotsMore";
import AssetMoreInfo from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetMoreInfo";
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";

export default {
  name: "InvestmentAssetItem",
  components: {TransitionCollapseHeight, AssetMoreInfo, IconDotsMore, AssetIcon},
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      moreInfo: false
    }
  },
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
    ...mapGetters('cabinet/currencies', ['getCurrencyByCode', 'displayCurrencyValue']),
    assetCurrency() {
      return this.getCurrencyByCode(this.asset.currency)
    }
  }
}
</script>

<style lang="scss">
.invest-asset__popover.tooltip.popover {
  .popover-inner {
    @apply py-2 px-0 border border-textColor-lighten;

    .invest-asset__btn {
      @apply block w-full min-w-40 pl-4 pr-5 py-1
      bg-transparent cursor-pointer
      transition duration-200
      text-left text-xs text-textColor;
      svg {
        @apply w-3 mr-2;
      }

      &:hover, &:focus {
        @apply bg-primary-light text-primary outline-none;
      }
    }
  }

  .popover-arrow {
    @apply hidden;
  }
}
</style>